import axios from 'axios'
import { HTTP_REQUEST_URL } from '/config.js'
// let baseURL = "https://bigdata.vend7.com"
let baseURL = HTTP_REQUEST_URL

let http = (url, data, fn, type, fail) => {


     axios({
        url: baseURL + url,
        method: type ? type : 'post',
        data: data,
    })
        .then(res => {
             fn(res)
        })
        .catch(
            err => {
                console.log('请求失败', err)
                if (fail) {
                    fail(err)
                }
            }
        );
}


export default http